var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": !_vm.tooltip
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('span', _vm._g(_vm._b({
          staticClass: "disabled-tooltip-activator d-inline-flex",
          "class": _vm.wrapperClass
        }, 'span', attrs, false), on), [_vm._t("default")], 2)];
      }
    }], null, true)
  }, [_c('span', [_vm._v(_vm._s(_vm.tooltip))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }